import auth from './auth'
import coupons from './coupons'
import discussion from './discussion'
import insights from './insights'
import lectureContent from './lectureContent'
import lectureDiscussion from './lectureDiscussion'
import lectures from './lectures'
import notifications from './notifications'
import orders from './orders'
import participants from './participants'
import payment from './payment'
import promotions from './promotions'
import recommends from './recommends'
import replies from './replies'
import stats from './stats'
import users from './users'

export {
  auth,
  coupons,
  orders,
  promotions,
  recommends,
  users,
  lectures,
  insights,
  participants,
  replies,
  payment,
  stats,
  lectureContent,
  notifications,
  lectureDiscussion,
  discussion
}



// WEBPACK FOOTER //
// ./src/models/index.ts